import {SimplePresentation} from "./SimplePresentationRunner";
import {Possessed} from "../../Possessed";
import {SimpleReelModelState} from "../../../core/reel/simplereel/SimpleReelModel";
import {gsap} from "gsap";
import {PossessedSymbol} from "../../reels/PossessedSymbol";
import {PossessedStatics} from "../../config/PossessedStatics";

export class XWaysPresentation extends SimplePresentation {

    private muteSounds = false;

    constructor() {
        super("XWaysPresentation");
    }

    shouldRun(): boolean {
        return Possessed.model.getXWaysSymbols().length > 0;
    }

    skip() {
        this.muteSounds = true;
        this.tl.progress(1);
        Possessed.soundPlayer.stopSound("xwaysLand");
        Possessed.soundPlayer.stopSound("xwaysReveal");

        const xWaysSymbols = Possessed.model.getXWaysSymbols();
        const has3ways = xWaysSymbols.find(s => s.targetSize == 3);
        const sound = has3ways ? "xwaysRevealX3" : "xwaysRevealX2";
        if(!Possessed.soundPlayer.isSoundPlaying(sound)) {
            Possessed.soundPlayer.playSound(sound);
        }
    }

    buildTimeline() {
        this.muteSounds = false;
        const tl = this.tl;
        const xWaysSymbols = Possessed.model.getXWaysSymbols();
        if(xWaysSymbols.length == 0) return;

        const revealing3Ways = xWaysSymbols.find(s => s.targetSize == 3);

        let playedRevealSound = false;

        xWaysSymbols.forEach((sym, index) => {
            const revealTL = gsap.timeline();

            const newSymbol =
                Possessed.reelView.createSymbol(sym.newSymbol,
                    SimpleReelModelState.IDLE,
                    sym.reelID,
                    sym.reelPosition);
            newSymbol.spriteView.alpha = 0;
            const oldSym = Possessed.reelView.getVisibleSymbolAt(sym.reelID, sym.reelPosition);
            revealTL.add(newSymbol.playXwaysReveal());
            revealTL.add(() => {
                if(!this.muteSounds)
                    Possessed.soundPlayer.playSoundNoOverlap("xwaysReveal");
            }, "<");
            revealTL.add(gsap.to(oldSym, {alpha: 0, duration: 1}), '<');
            revealTL.add(gsap.to(newSymbol.spriteView, {alpha: 1, duration: 1}), "<")
            revealTL.add(() => {
                Possessed.reelView.replaceSymbolAt(sym.reelID, sym.reelPosition, newSymbol);
            })
            revealTL.add(newSymbol.playWaysReveal(sym.targetSize), ">-0.37");
            if(!this.muteSounds && !playedRevealSound) {
                const sound = revealing3Ways ? "xwaysRevealX3" : "xwaysRevealX2";
                revealTL.add(() => {
                    Possessed.soundPlayer.playSound(sound);
                }, "<")
                playedRevealSound = true;
            }

            revealTL.add(()=> {
                newSymbol.setXWays(sym.targetSize);
            })

            //tl.add(revealTL, index == 0 ? "<" : "<0.3");
            tl.add(revealTL, index == 0 ? ">" : "<");
        })

        tl.add(() => {}, '>0.3');
    }
}